import { $applyNodeReplacement } from "lexical";
import type { ReactNode } from "react";
import { CustomEmoji } from "./custom-emoji";
import { CustomEmojiNode, type SerializedCustomEmojiNode } from "./custom-emoji-node";

export class CustomEmojiNodeMui extends CustomEmojiNode {
  static getType(): string {
    return super.getType();
  }

  static clone(node: CustomEmojiNodeMui): CustomEmojiNodeMui {
    return new this(node.__name, node.__key);
  }

  static importJSON(serializedNode: SerializedCustomEmojiNode): CustomEmojiNodeMui {
    return new this(serializedNode.name);
  }

  exportJSON(): SerializedCustomEmojiNode {
    return super.exportJSON();
  }

  decorate(): ReactNode {
    return <CustomEmoji name={this.__name} />;
  }
}

export function $createCustomEmojiNodeMui(name: string): CustomEmojiNode {
  return $applyNodeReplacement(new CustomEmojiNodeMui(name));
}
